import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import produce from 'immer';

import {
    VerificationService,
    Locale,
    ViewModel,
    getLocaleSafely,
    FaqLinkComponent,
    getSafe,
} from '@sheerid/jslib';
import { PrivacyPolicyLinkComponent } from './PrivacyPolicyLinkComponent';


interface FormFooterProps {
    verificationService?: VerificationService;
    children?: any;
}

const FormFooterComponent = ({ verificationService, children }: FormFooterProps) => {
    const viewModel = verificationService ? verificationService.viewModel : undefined;
    const updateViewModel = verificationService ? verificationService.updateViewModel : undefined;
    const locale: Locale = viewModel ? getLocaleSafely(viewModel) : undefined;
    const privacyPolicyRef = React.useRef<any>({});
    const cleanupCommonTags = /(<div[^>]+>|<div>|<\/div>)|(<span[^>]+>|<span>|<\/span>)|(<p[^>]+>|<p>|<\/p>)/gm;

    // Store the footer message that the user was shown when the user submitted
    React.useEffect(() => {
        if (!privacyPolicyRef.current || !verificationService) {
            return;
        }
        const privacyPolicyText = privacyPolicyRef.current.innerHTML.replace(cleanupCommonTags, '');
        const updatedViewModel = produce(viewModel, (draft: ViewModel) => {
            if (!draft.metadata) {
                draft.metadata = {};
            }
            draft.metadata.submissionOptIn = privacyPolicyText;
        });

        updateViewModel(updatedViewModel);
    }, [privacyPolicyRef, locale]);

    return (
        <div className="sid-footer sid-l-space-top-md">
            <div>
                <div className="sid-footer__one" ref={privacyPolicyRef}>
                    {children ? children : (
                        <div>
                            <FormattedHTMLMessage
                                id="infoShared1"
                                defaultMessage=
                                    "By clicking, I consent to processing my information for the purpose of verifying my eligibility as described within the {privacyPolicyLink}"
                                values= {{ privacyPolicyLink: '' }}
                            />
                            <PrivacyPolicyLinkComponent verificationService={verificationService || undefined} />
                        </div>
                    )}
                </div>
                {
                    verificationService && getSafe(() => verificationService.verificationResponse.segment, undefined) ?
                        <div className="sid-footer__two sid-l-space-top-md">
                            <FormattedHTMLMessage id="see" defaultMessage="See"/>
                            &nbsp;
                            <FaqLinkComponent verificationService={verificationService} />
                            &nbsp;
                            <FormattedHTMLMessage id="forMoreDetail" defaultMessage="for more detail."/>
                        </div>
                    : null
                }
            </div>
        </div>
    );
};

export { FormFooterComponent };
